import React, { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import AuthContext from '../AuthContext';

const Header = () => {
    const navigate = useNavigate();
    const { logout } = useContext(AuthContext);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const userName = localStorage.getItem('name') || 'User';
    const initials = userName
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((n) => n[0]?.toUpperCase())
        .join('') || 'U';

    return (
        <nav
            className="main-header navbar navbar-expand"
            style={{
                background: '#ffffff',
                borderBottom: '1px solid #e7e5f0',
                boxShadow: '0 1px 2px rgba(30,27,46,0.04)',
                position: 'sticky',
                top: 0,
                zIndex: 1030,
                padding: '0 20px',
            }}
        >
            {/* Left navbar links */}
            <ul className="navbar-nav align-items-center">
                <li className="nav-item">
                    <a
                        className="nav-link"
                        data-widget="pushmenu"
                        href="#"
                        role="button"
                        style={{ color: '#4b4a5a', fontSize: '1.05rem' }}
                    >
                        <i className="fas fa-bars"></i>
                    </a>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <Link to="/dashboard" className="nav-link" style={{ color: '#4b4a5a', fontWeight: 600 }}>
                        Home
                    </Link>
                </li>
            </ul>

            {/* Center: Company Name */}
            <div className="mx-auto d-none d-sm-block text-center">
                <strong style={{ fontSize: '1.15rem', letterSpacing: '0.2px', color: '#1e1b2e', fontWeight: 800 }}>
                    Eazyworld EHS Engineering Private Ltd
                </strong>
            </div>

            {/* Right navbar links */}
            <ul className="navbar-nav ml-auto align-items-center">
                <li className="nav-item dropdown">
                    <a
                        className="nav-link dropdown-toggle d-flex align-items-center"
                        data-toggle="dropdown"
                        href="#"
                        role="button"
                        style={{ gap: '10px' }}
                    >
                        <span
                            style={{
                                width: '34px',
                                height: '34px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #4f46e5, #818cf8)',
                                color: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 700,
                                fontSize: '0.85rem',
                                flexShrink: 0,
                            }}
                        >
                            {initials}
                        </span>
                        <span className="d-none d-md-inline" style={{ color: '#1e1b2e', fontWeight: 600 }}>
                            {userName}
                        </span>
                    </a>
                    <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right animated fadeInDown" style={{ minWidth: '230px' }}>
                        <div className="text-center" style={{ padding: '14px 10px 12px' }}>
                            <span
                                style={{
                                    width: '52px',
                                    height: '52px',
                                    borderRadius: '50%',
                                    background: 'linear-gradient(135deg, #4f46e5, #818cf8)',
                                    color: '#fff',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontWeight: 700,
                                    fontSize: '1.1rem',
                                    marginBottom: '8px',
                                }}
                            >
                                {initials}
                            </span>
                            <p className="mb-0" style={{ fontWeight: 700, color: '#1e1b2e' }}>{userName}</p>
                            <small style={{ color: '#8a8896' }}>Logged In</small>
                        </div>
                        <div className="dropdown-divider"></div>
                        <Link to="/profile" className="dropdown-item">
                            <i className="fas fa-user mr-2 text-primary"></i> Profile
                        </Link>
                        <Link to="/changepassword" className="dropdown-item">
                            <i className="fas fa-key mr-2 text-warning"></i> Change Password
                        </Link>
                        <div className="dropdown-divider"></div>
                        <button className="dropdown-item text-danger" onClick={handleLogout} style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left' }}>
                            <i className="fas fa-sign-out-alt mr-2"></i> Logout
                        </button>
                    </div>
                </li>
            </ul>
        </nav>
    );
};

export default Header;
